<template>
  <div>
    <TableList
      class="shopGoodsTable"
      ref="table"
      :cols="cols"
      :list="list"
      :height="tableHeight"
      :rowHeight="100"
    >
      <template slot="shopInfoSlot" slot-scope="{ row }">
        <div>
          <div>店铺商品id: {{ row.numIid }}</div>
          <div v-show="searchType == 1">店铺规格id: {{ row.skuId }}</div>
        </div>
      </template>
      <template slot="operateStatusSlot" slot-scope="{ row }">
        <span>{{getOperateStatus(row.operateStatus)}}</span>
      </template>
      <template slot="operateTimeSlot" slot-scope="{ row }">
        <span>{{formatTime(row.operateTime)}}</span>
      </template>
    </TableList>
     <!-- 编辑窗口 -->
    <EditDialog ref="editDialog" @search="formUpdated => formUpdated ? $emit('search') : null"/>
  </div>
</template>

<script>
import EditDialog from "@/components/prod/center/dialogs/EditDialog.vue";
import TableList from "@/components/TableList.vue";
import prod_center_dictionary from "@/components/prod/center/dictionary.js";
import tableMixins from '@mixins/table-mixins';
import { mapActions, mapMutations, mapGetters} from "vuex";
import dayjs from "dayjs";

export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    searchType:{
      type:Number,
      default: 1,
    },
    mode: {
      type: String,
      default: "supplier",
    },
  },
  mixins: [new tableMixins(176,{ refName:'searchRef' })],
  components: {
    TableList,
    EditDialog
  },
  data() {
    return {
      cols:[]
    };
  },
  computed: {
    ...mapGetters(['routerPrefix']),
    // cols(){
    //   if(this.searchType === 0){
    //     return [
    //     ]
    //   }else{
    //     return [
    //         { prop: "shopInfo", attrs: { label: "商品信息" }, slot: true},
    //         { prop: "skuOuterId", attrs: { label: "平台规格商家编码" }},
    //         { prop: "action", attrs: { label: "操作类型" }  },
    //         { prop: "remark", attrs: { label: "操作详情" } },
    //         { prop: "staffName", attrs: { label: "操作人" }},
    //         { prop: "operateStatus", attrs: { label: "操作状态" },slot: true },
    //         { prop: "operateTime", attrs: { label: "操作时间" },slot: true },
    //     ]
    //   }
    // },
  },
  watch:{
    searchType:{
      handler(val){
        if(val === 0){
          this.cols = [
            { prop: "shopInfo", attrs: { label: "商品信息" }, slot: true},
            // { prop: "outerId", attrs: { label: "款式编码" } },
            { prop: "outerId", attrs: { label: "平台主商家编码" } },
            { prop: "action", attrs: { label: "操作类型" } },
            // { prop: "supply", attrs: { label: "状态" } },
            { prop: "remark", attrs: { label: "操作详情" } },
            // { prop: "detail", attrs: { label: "处理状态" } },
            { prop: "staffName", attrs: { label: "操作人" } },
            { prop: "operateStatus", attrs: { label: "操作状态" },slot: true },
            { prop: "operateTime", attrs: { label: "操作时间" },slot: true },
          ]
        }else{
          this.cols = [
            { prop: "shopInfo", attrs: { label: "商品信息" }, slot: true},
            { prop: "skuOuterId", attrs: { label: "平台规格商家编码" }},
            { prop: "action", attrs: { label: "操作类型" }  },
            { prop: "remark", attrs: { label: "操作详情" } },
            { prop: "staffName", attrs: { label: "操作人" }},
            { prop: "operateStatus", attrs: { label: "操作状态" },slot: true },
            { prop: "operateTime", attrs: { label: "操作时间" },slot: true },
          ]
        }
      },
      immediate:true
    }
  },
  mounted() {
  },
  methods: {
    formatTime(time){
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss')
    },
    getOperateStatus(status){
      let map = {
        0:'失败',
        1:'成功',
      }
      return map[status] || '-'
    }
  },
};
</script>

<style lang="scss" scoped>
.shopGoodsTable{
  ::v-deep .el-table__body .cell{
    height: auto !important;
  }
}
</style>
